// extracted by mini-css-extract-plugin
export default {"listCards":"yQaFYhZp0r9Bygk5spiw","titleBox":"D1rCJ4JjDeF2CyU1rVW8","cards":"NrUV4mD2LirhfRagewIa","card":"p4fPQ4j3I_6F7n_5YsLo"};